import socket, { invokeRPC } from './socket.js';

export function getOnlineUserList () {
  return invokeRPC('adminReports', 'getOnlineUserList')
}

export function getLoginHistory (data) {
  return invokeRPC('adminReports', 'getLoginHistory', data)
}

export function cleanupStaleSessions() {
  return invokeRPC('adminReports', 'cleanupStaleSessions')
}

export function getUsageReport (data) {
  return invokeRPC('adminReports', 'getUsageReport', data)
}

export function exportUsageReportPdf (data) {
  return invokeRPC('adminReports', 'exportUsageReportPdf', data)
}

export function sendEmailUsageReport (data) {
  return invokeRPC('adminReports', 'sendEmailUsageReport', data)
}